import { useAppDispatch, useAppSelector } from '../../../../../../hooks/ReduxHook';
import { useNotification } from '../../../../../../hooks/useNotification';
import { BaseFormConfig, CompleteSignUpPayload, SubTypes } from '../../../../Auth/logic/Auth.types';
import { useAuthLogic } from '../../../../Auth/logic/useAuth.logic';
import { useAccountSwitcher } from '../../AccountSwitcher/logic/useAccountSwitcher';
import { setHasSelected, setOpen } from './CreateAccount.reducer';
import { titleCase } from '../../../../../../util/helpers';
import { useEffect, useState } from 'react';

export const useCreateAccount = (refetch: any) => {
  const dispatch = useAppDispatch();
  const notification = useNotification();
  const state = useAppSelector((state) => state.createAccount);
  const { error, isLoading, doCompleteSignUp, selectAccountType, callSignupConfigApi, selectSubAccountType, formInfo } =
    useAuthLogic();

  // TODO talk to Parsa about this method
  const [signUpConfigData, setSignUpConfigData] = useState<any>();
  useEffect(() => {
    callSignupConfigApi()
      .unwrap()
      .then((data: any) => {
        console.log(data);
        setSignUpConfigData(data);
      });
  }, []);

  const { doSetModalTitle, doReset } = useAccountSwitcher();
  const doToggleOpen = (state: boolean) => dispatch(setOpen({ isOpen: state }));

  const onSelectionClick = (item: BaseFormConfig) => {
    doSetModalTitle(`Create ${item?.key} Account`);
    selectAccountType(item.key, true);
    dispatch(setHasSelected({ hasSelected: true }));
  };

  const onSignup = (data: CompleteSignUpPayload) =>
    doCompleteSignUp(
      data,
      () => {
        notification.success({
          message: 'The account has been added successfully.',
        });
        setTimeout(() => {
          doReset();
          if (refetch && typeof refetch === 'function') {
            refetch();
          }
        }, 500);
      },
      () => {
        notification.error({
          message: 'Failed to add new account',
          description: '',
        });
      },
    );

  return {
    isOpen: state.isOpen,
    isLoading,
    error,

    hasSelectedType: !!(state.hasSelected && (formInfo?.accountType || formInfo?.subAccountType)),
    selectedSubtype: (state.hasSelected && formInfo?.subAccountType) || '',
    selectSubAccountType,

    getSelectedFields: (state.hasSelected && formInfo?.getFields()) || [],
    getSelectedTypes: (state.hasSelected && formInfo?.getTypes()) || [],

    toggleOpen: doToggleOpen,
    doCompleteSignUp: onSignup,
    doSetModalTitle,
    onSelectionClick,

    signUpConfigData,
  };
};
